module.exports = __webpack_public_path__ + "media/images/admin/icons/more-horizontal-43ecf751e62ad2cc0518828d94a22f0d.svg";